import Head from 'next/head';
import { useRouter } from 'next/router';
import { ReactElement, useEffect } from 'react';
import Header from '../components/Header';
import SignupOptions from '../components/SignupOptions';
import Page from '../components/Page';
import styles from './index.module.scss';
import SauceBenefits from '../components/SauceBenefits';
import SauceBenefitsCcy from '../components/SauceBenefitsCcy';
import SignInDisclaimer from '../components/SignInDisclaimer';
import { getRedirectAttribute, getRedirectUrl } from '../utils/helper';
import getQueryString from '../utils/query';
import { setCookiesWithDomain } from '../utils/cookies';

type PageData = {
  title: string;
  tagline: string;
};

const modes: { [key: string]: PageData } = {
  pricing: {
    title: 'Start testing in minutes',
    tagline: 'Please complete this form to get your order underway!',
  },
  default: {
    title: 'Start testing in minutes',
    tagline: 'Get your free account today. No credit card required',
  },
};

const MARKETING_PARAMS = ['utm_campaign', 'utm_medium', 'utm_source', 'utm_keyword', 'utm_content', 'utm_term', 'gclid'];

export const getServerSideProps = async (context: any) => {
  const { query } = context;
  const redirect = getRedirectAttribute(query);

  return {
    redirect,
    props: {},
  };
};

export default function Home(): ReactElement {
  const router = useRouter();

  const { referrer } = router.query;

  // collects marketing params in a simpler format:
  // stored as a string as they include a long list:
  // gclid, utm_source, utm_medium, utm_campaign, utm_term
  const queryParams: string = getQueryString(router.query);

  const isCcy = true;

  const mode = referrer === 'pricing' ? 'pricing' : 'default';

  const pageData: PageData = modes[mode];

  useEffect(() => {
    const fetchdata = async () => {
      const result = await getRedirectUrl();
      if (result) router.push(result);
    };
    fetchdata();

    // convert the marketing params into cookie values
    // get the expiry date string for the cookie to expire in 90 days
    const currentDate = new Date();
    const dateIn90Days = new Date(currentDate.getTime() + 90 * 24 * 60 * 60 * 1000);

    MARKETING_PARAMS.forEach((param) => {
      const value: string | string[] | undefined = router.query[param];
      if (typeof value === 'string') {
        setCookiesWithDomain(param, value as string, dateIn90Days);
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page>
      <div className={styles.container}>
        <Head>
          <title>Sign Up for a Free Trial | Sauce Labs</title>
        </Head>
        <Header />
        <main className={styles.main}>
          <div className={styles.submain}>
            <h1 id="title">{pageData.title}</h1>
            <p className={styles.tagline} id="tagline">
              {pageData.tagline}
            </p>
            <SignupOptions queryParams={queryParams} />
            <SignInDisclaimer />
          </div>
          {!isCcy && <SauceBenefits />}
          {isCcy && <SauceBenefitsCcy />}
        </main>
      </div>
    </Page>
  );
}
